<template>
  <div>
    <v-progress-linear indeterminate v-if="!distributor"></v-progress-linear>
    <v-flex v-if="distributor">
      <div class="d-flex align-center">
        <div class="d-flex justify-start">
          <v-flex>
            <h1 class="d-inline-block" style="cursor: pointer; color: #1565C0" @click="$router.push(dpath)">{{dpathName}}</h1>
            <h1 class="d-inline-block" >&nbsp;/ {{name}}</h1>
          </v-flex>
        </div>
        <v-layout row justify-end>
          <v-dialog v-if="!parseInt(distributor[0].count)" v-model="dialogDelete" max-width="400px">
            <v-btn  color="error" slot="activator" dark>Delete</v-btn>
            <v-card>
              <v-card-title class="headline">Delete Distributor?</v-card-title>
              <v-card-text>Are you sure you want to delete {{ distributor.name }}?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat="flat" @click.native="dialogDelete = false">Cancel</v-btn>
                <v-btn color="green darken-1" flat="flat" @click="deleteDistributor">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" persistent max-width="700px">
            <v-btn color="primary" dark slot="activator">Update</v-btn>
            <dialog-distributor
              :distributorInit.sync="distributor[0]"
              :title="dialogTitle"
              @close="dialog = false"
              @save="updateDistributor"
            ></dialog-distributor>
          </v-dialog>
          <v-btn color="success" class="mr-0" @click="getBasicStatistics">{{activatedBasicStat ? 'update activations info' : 'get activations info' }}</v-btn>
        </v-layout>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="distributor"
          class="elevation-1"
          hide-actions
        >
          <template slot="headerCell" slot-scope="props">
            <h3 slot="activator">
              {{ props.header.text }}
            </h3>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.shortName }}</td>
            <td>{{ props.item.count }}</td>
            <td>{{ props.item.createdAt | moment }}</td>
            <td>{{ props.item.updatedAt | moment }}</td>
            <td>
              <div v-for="(i, index) in props.item.countries" :key="i.id" class="d-inline-block">
                <v-chip dark v-if="index < maxCountries"
                        @click="$router.push(`/countries/${i.name}`)">
                  {{ i.name }}
                </v-chip>
                <v-chip v-if="index === maxCountries" @click.native="maxCountries = 1000">
                  <v-icon>expand_more</v-icon>
                </v-chip>
                <v-chip v-if="index <= maxCountries && index > saveMaxCountries && index === props.item.countries.length - 1" @click.native="maxCountries = saveMaxCountries">
                  <v-icon>expand_less</v-icon>
                </v-chip>
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
      <div class="mt-5">
        <v-data-table
          :headers="headersBasicStat"
          :items="activatedBasicStat"
          v-if="activatedBasicStat"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td class="red--text"><b>{{ props.item.activated }}</b></td>
            <td class="green--text"><b>{{ props.item.android }}</b></td>
            <td class="blue--text"><b>{{ props.item.ios }}</b></td>
          </template>
        </v-data-table>
      </div>
      <codes
        ref="codes"
        :distributor="id"
        class="mt-5"
      ></codes>
      <v-snackbar
        :timeout="3000"
        :bottom="true"
        :right="true"
        :multi-line="false"
        v-model="snackBar"
      >
        {{ snackBarText }}
        <v-btn flat color="pink" @click.native="snackBar = false">Close</v-btn>
      </v-snackbar>
    </v-flex>
  </div>
</template>

<script>
import api from '../../api/distributors'
import Codes from '@/components/Codes/Index'
import moment from 'moment'
import DialogDistributor from '@/components/Distributors/Dialog'
import {DISTRIBS_UPDATE, DISTRIBS_DELETE, DISTRIBS_SINGLE} from '../../store/actions/distributors'

export default {
  data: () => ({
    maxCountries: 10,
    saveMaxCountries: 10,
    dpathName: 'Distributors',
    distributor: null,
    dialogTitle: 'Update Distributor',
    dialog: false,
    dialogDelete: false,
    snackBarText: 'Input is not valid!',
    snackBar: false,
    activatedBasicStat: null,
    headers: [
      { text: 'Short Name', sortable: false, value: 'shortName' },
      { text: 'Codes count', sortable: false, value: 'count' },
      { text: 'Created At', sortable: false, value: 'createdAt' },
      { text: 'Updated At', sortable: false, value: 'updatedAt' },
      { text: 'Countries', sortable: false, value: 'countries' }
    ],
    headersCodes: [
      {
        text: 'Codes Common Name',
        sortable: false,
        value: 'name'
      },
      { text: 'Blocks Count', value: 'blocksCount' },
      { text: 'SKU', value: 'sku.name' },
      { text: 'Codes count', value: 'count' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Status', value: 'status' }
    ],
    headersBasicStat: [
      { text: 'Codes activated', sortable: false, value: 'activated' },
      { text: 'Android activations', sortable: false, value: 'android' },
      { text: 'iOS activations', sortable: false, value: 'ios' }
    ]
  }),
  computed: {
    name: function () {
      if (this.distributor && this.distributor[0]) {
        return this.distributor[0].name
      }
      return ''
    },
    id: function () {
      if (this.distributor && this.distributor[0]) {
        return this.distributor[0].id
      }
      return null
    },
    dpath: function () {
      if (!this.$route.query.p) {
        return '/distributors'
      }
      return `/distributors?p=${this.$route.query.p}`
    },
    codes: function () {
      if (this.distributor && this.distributor[0]) {
        return this.distributor[0].codes
      }
      return []
    }
  },
  methods: {
    getBasicStatistics: async function () {
      try {
        this.activatedBasicStat = await api.getActivations(this.distributor[0].id)
        this.$refs.codes.getAllActivationsInfo()
        console.log(this.activatedBasicStat)
      } catch (err) {
        this.snackBar = true
        this.snackBarText = 'Distributor not found'
        console.log(err)
      }
    },
    changeDistributor: async function (id) {
      try {
        this.distributor = await this.$store.dispatch(DISTRIBS_SINGLE, {id})
      } catch (err) {
        this.snackBar = true
        this.snackBarText = 'Distributor not found'
        console.log(err)
      }
    },
    updateDistributor: async function (distributor) {
      const newOne = await this.$store.dispatch(DISTRIBS_UPDATE, { id: this.$route.params.id, distributor })
      if (newOne) {
        this.distributor = newOne
        this.dialog = false
      } else {
        this.snackBar = true
        this.snackBarText = 'Distributor with same name exist'
      }
    },
    deleteDistributor: async function () {
      const deleted = await this.$store.dispatch(DISTRIBS_DELETE, { id: this.$route.params.id })
      if (deleted) {
        this.dialogDelete = false
        this.$router.push(this.dpath)
      } else {
        this.snackBar = true
        this.snackBarText = 'Something went wrong'
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM DD YYYY, hh:mm:ss')
    },
    countriesFilter: function (countries) {
      if (!countries) {
        return ''
      }
      let string = ''
      countries.forEach(function (item, i) {
        if (i) {
          string += ', '
        }
        string += item
      })
      return string
    }
  },
  created: async function () {
    await this.changeDistributor(this.$route.params.id)
  },
  watch: {
    '$route': async function (to) {
      await this.changeDistributor(to.params.id)
    }
  },
  components: {
    DialogDistributor,
    Codes
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Distributors/SingleDistributor.vue